import { UseQueryResult } from '@tanstack/react-query';
import { CollapseProps, Descriptions, Grid, Typography } from 'antd';
import { AxiosResponse } from 'axios';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import CollapseCustom from 'src/components/v2/Collapse';
import { HRTicketStatusTag } from 'src/components/v2/Tag/TicketStatusTag/TicketStatusTag';
import urlPath from 'src/constants/urlPath';
import { ITransportationTicket } from 'src/types/hr_ticket/transportationTicket.type';
import { formatDateTime } from 'src/utils/utils';
const { Text } = Typography;

const transportationTicketItems = (
  transportationTickets: ITransportationTicket[],
  colspan: number
): CollapseProps['items'] => {
  return transportationTickets.map((item) => ({
    key: item.id,
    label: (
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
        key={item.id}
      >
        <Descriptions.Item label='Mã'>
          <Link to={`${urlPath.myTransportationTicket.location}/${item.id}`}>{item.code}</Link>
        </Descriptions.Item>
        <Descriptions.Item label='Trạng thái'>
          <HRTicketStatusTag ticketStatus={item.ticketStatus} confirmedType={item.confirmedType} />
        </Descriptions.Item>
        <Descriptions.Item label='Người lập phiếu'>
          <Text>{item.createdBy?.fullName}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ngày tạo'>
          <Text>{formatDateTime(item?.createdDate)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Khoảng cách' span={colspan}>
          <Text>{item.distance + ' KM'}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Nơi đi' span={colspan}>
          {item.departureAddress ? item.departureAddress + ', ' : ''} {item.departureIdInString}
        </Descriptions.Item>
        <Descriptions.Item label='Nơi đến' span={colspan}>
          {item.destinationAddress ? item.destinationAddress + ', ' : ''} {item.destinationIdInString}
        </Descriptions.Item>
        <Descriptions.Item label='Ghi chú' span={colspan}>
          {item.note}
        </Descriptions.Item>
      </Descriptions>
    ),
    showArrow: false,
    className: 'transportation-ticket-collapse-item'
  }));
};

export default function TransportationTicket(
  refTransportationTicketsForTicketQuery: UseQueryResult<AxiosResponse<ITransportationTicket[], any>, unknown>
) {
  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const colspan = breakpoints.xxl ? 2 : 1;

  return (
    <Fragment>
      {refTransportationTicketsForTicketQuery?.data?.data &&
        refTransportationTicketsForTicketQuery?.data?.data.length > 0 && (
          <CollapseCustom
            isFullDefault
            title='Danh sách phiếu vận chuyển'
            titleLevel={5}
            isSegmented={false}
            collapsible='disabled'
            items={transportationTicketItems(refTransportationTicketsForTicketQuery?.data.data || [], colspan)}
            expandIconPosition='end'
            className='transportation-ticket-collapse'
          />
        )}
    </Fragment>
  );
}
